import { render, staticRenderFns } from "./WordCloudSvg.vue?vue&type=template&id=0b6b6634&lang=pug&"
import script from "./WordCloudSvg.vue?vue&type=script&lang=ts&"
export * from "./WordCloudSvg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports